import ManageProfile from "./ManageProfile";

export default ManageProfile;
